import { render, staticRenderFns } from "./StatisticsCompanyAndUserTypeSchool.vue?vue&type=template&id=0db262cc&scoped=true"
import script from "./StatisticsCompanyAndUserTypeSchool.vue?vue&type=script&lang=ts"
export * from "./StatisticsCompanyAndUserTypeSchool.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsCompanyAndUserTypeSchool.vue?vue&type=style&index=0&id=0db262cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db262cc",
  null
  
)

export default component.exports